:host {
    display: block;
}

.jb-date-input-web-component {
    width: 100%;
    margin: var(--margin);
    position: relative;

    [slot="inline-start"]{
        display: contents;
    }
    .date-input-inline-end {
        display: flex;
        gap:0.5rem;
        .calendar-trigger {
            all: unset;
            box-sizing: border-box;
            display: var(--calendar-trigger-display, block);
            width: var(--calendar-trigger-width);
            height: var(--calendar-trigger-height);
            cursor: pointer;

            &:disabled {
                cursor: default;
            }
            object-fit: contain;

            &:focus-visible {
                outline: 2px solid var(--jb-date-input-focus-ring-color, Highlight);
                outline-offset: 2px;
            }

            &.--active {
                svg {
                    .cls-1 {
                        fill: var(--calendar-icon-color-active);
                    }
                }
            }

            svg {
                width: 100%;
                height: 100%;

                .cls-1 {
                    fill: var(--calendar-icon-color);

                }
            }
        }
    }
    jb-popover{
        --jb-popover-z-index: var(--calendar-popover-z-index);
        position: relative;
        z-index: var(--calendar-popover-z-index);
    }
}
